import {Component} from 'preact';
import messages from '../messages/messages.js';
import Sentry from '../lib/sentry.js';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error, {contexts: {react: {componentStack: errorInfo.componentStack}}});
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="p-8 m-8 border border-red-600 rounded-lg bg-red-50">
                    <h1 className="text-2xl font-bold text-red-600 mb-4">
                        Oops! Something went wrong
                    </h1>
                    <p className="text-gray-700 mb-4">
                        We're sorry for the inconvenience. An unexpected error occurred while loading this page. Our team has been automatically notified and is investigating the issue.
                    </p>
                    <p className="text-gray-700 mb-6">
                        <strong>In the meantime:</strong>
                    </p>
                    <ul className="text-gray-700 mb-6 list-disc list-inside">
                        <li>Try refreshing the page or clearing your browser cache</li>
                        <li>If the problem persists, please reach out to our support team</li>
                        <li>Join our Discord community for real-time support and updates</li>
                    </ul>
                    <p className="text-gray-700 mb-6">
                        <strong>Need help?</strong> <a href={messages["DISCORD_URL"]} target="_blank" rel="noopener noreferrer">Join our Discord server</a>
                    </p>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
